export const productsUrl = 'https://bestayush.com/products/';

export const whatsappUrl =
  'https://wa.me/917418578761?text=Hello%20Best%20Research%20Pharma%2C%20I%20would%20like%20to%20know%20more%20about%20your%20products.';

export const footerLogo =
  'https://storage.helloreaddy.io/project_files/5953e1e0-88d4-4f3c-bdca-e57eb80d5b40/d1e999ee-6714-4e38-b17c-451e8559c979_compressed_LOGO-best.webp';

export const brandInfo = {
  name: 'Best Research Pharma',
  tagline: 'Ayurvedic Medicine Manufacturers',
  phonePrimary: '+91 74185 78761',
  phoneSecondary: '+91 74185 78761',
  phoneThird: '+91 98421 78761',
  email: 'bestresearchpharma@gmail.com',
  website: 'https://bestayush.com/',
  addressLines: [
    '13.A, Habiba Manzil,',
    'Sankar Nagar 2nd Street,',
    'K.Pudur, Madurai - 625 007',
    'Tamil Nadu, India',
  ],
  logo: 'https://www.bestayush.com/images/logo/img_6a72c7185d3043.50455465.webp',
  mapEmbed:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.8601368313866!2d78.14593061524634!3d9.945592992888484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c5ce35901433%3A0x40c7930950564ee3!2sBest+Research+Pharma!5e0!3m2!1sen!2sin!4v1512192786925',
};

export const socialLinks = [
  { id: 'facebook', label: 'Facebook', icon: 'ri-facebook-fill', url: 'https://www.facebook.com/BESTRESEARCHMDU/' },
  { id: 'instagram', label: 'Instagram', icon: 'ri-instagram-fill', url: 'https://www.instagram.com/bestayush_official/' },
  { id: 'youtube', label: 'YouTube', icon: 'ri-youtube-fill', url: 'https://www.youtube.com/@bestresearchpharma' },
  { id: 'google', label: 'Google Business', icon: 'ri-google-fill', url: 'https://www.google.com/maps/search/Best+Research+Pharma+Madurai' },
];

export const heroSlides = [
  {
    id: 'rds-pain-balm',
    eyebrow: 'Ayurvedic Pain Relief',
    title: 'Natural Relief for Every Pain, Every Day',
    tagline: 'RDS Pain Balm — Fast acting, long lasting relief from headache, body ache, joint & muscle pain.',
    image: 'https://www.bestayush.com/images/hero/img_6a72c76b4ce954.89978443.webp',
  },
  {
    id: 'diabetes-care',
    eyebrow: 'Complete Care',
    title: 'Complete Ayurvedic Diabetes Care',
    tagline: 'Traditional herbal formulations researched and crafted to support everyday wellness, naturally.',
    image: 'https://www.bestayush.com/images/hero/img_6a73931e9271b9.20702203.webp',
  },
];

export const stats = [
  { id: 'years', value: '31+', label: 'Years of Trust' },
  { id: 'products', value: '150+', label: 'Herbal Formulations' },
  { id: 'distributors', value: '300+', label: 'Distributors' },
  { id: 'states', value: '18+', label: 'States Served' },
];

export const welcomeVideo =
  'https://www.youtube.com/embed/Vg4gpjGz3SA?autoplay=1&mute=1&loop=1&playlist=Vg4gpjGz3SA&controls=1&rel=0';

export const certificates = [
  {
    id: 'state-licence',
    title: 'State Manufacturing Licence',
    image: 'https://www.bestayush.com/images/certificates/img_6a72e4779ebfc5.29519804.webp',
  },
  {
    id: 'gmp',
    title: 'Schedule T GMP Certificate',
    image: 'https://www.bestayush.com/images/certificates/img_6a72e47b914159.89433535.webp',
  },
  {
    id: 'iso',
    title: 'ISO 9001:2015 Certificate',
    image: 'https://www.bestayush.com/images/certificates/img_6a72e4a1de82d8.49605415.webp',
  },
  {
    id: 'halal',
    title: 'RDS Pain Balm Halal Certificate',
    image: 'https://www.bestayush.com/images/certificates/img_6a72e49e1a5368.75468386.webp',
  },
  {
    id: 'trademark',
    title: 'RDS Pain Balm Registered Trade Mark',
    image: 'https://www.bestayush.com/images/certificates/img_6a72e4a01e7d67.52616723.webp',
  },
  {
    id: 'technology',
    title: 'Technology Driven Ayurveda',
    image: 'https://www.bestayush.com/images/certificates/img_6a72e52b1804d5.76357403.webp',
  },
  {
    id: 'award',
    title: 'All India Ayurveda Award',
    image: 'https://www.bestayush.com/images/certificates/img_6a738f5e7238d6.15904237.webp',
  },
];

export const categoryCards = [
  {
    id: 'capsules',
    name: 'Capsules',
    icon: 'ri-capsule-line',
    description:
      'We manufacture a wide range of Ayurvedic products in convenient capsule form, delivering a precise herbal dose every single time.',
    image: 'https://www.bestayush.com/images/products/img_6a71b68b83eff7.24283507.webp',
    to: '/products/capsules',
  },
  {
    id: 'tablet',
    name: 'Tablets',
    icon: 'ri-medicine-bottle-line',
    description:
      'Traditional Ayurvedic tablets compressed from finely processed herbs, ideal for regular wellness routines and easy consumption.',
    image: 'https://www.bestayush.com/images/products/img_6a71d3cbe68d78.29139084.webp',
    to: '/products/tablet',
  },
  {
    id: 'syrup',
    name: 'Syrups',
    icon: 'ri-flask-line',
    description:
      'Soothing herbal syrups prepared with carefully selected botanicals, ideal for gentle everyday support and easy consumption.',
    image: 'https://www.bestayush.com/images/products/img_6a711df1687898.67193112.webp',
    to: '/products/syrup',
  },
  {
    id: 'lehyam',
    name: 'Lehyam',
    icon: 'ri-leaf-line',
    description:
      'Traditional lehyam prepared from age-old recipes with pure herbs, honey and ghee for nourishing, restorative care.',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Ayurvedic%20herbal%20lehyam%20paste%20in%20a%20clear%20glass%20jar%20with%20wooden%20spoon%20and%20honey%20textured%20herbal%20jam%2C%20warm%20natural%20lighting%2C%20pure%20white%20seamless%20background%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=lehyam-cat-cover-01&orientation=squarish',
    to: '/products/lehyam',
  },
  {
    id: 'oil',
    name: 'Oil',
    icon: 'ri-drop-line',
    description:
      'Slow-cooked herbal oils for therapeutic massage and daily hair and skin care, prepared with pure botanical infusions.',
    image: 'https://www.bestayush.com/images/products/img_6a71b446d83c31.93423824.webp',
    to: '/products/oil',
  },
  {
    id: 'ointments',
    name: 'Ointments',
    icon: 'ri-hand-sanitizer-line',
    description:
      'Pain balms, roll-ons and soothing ointments formulated for fast, targeted relief and topical comfort where you need it most.',
    image: 'https://www.bestayush.com/images/products/img_6a72d1fc7fa714.22576636.webp',
    to: '/products/ointments',
  },
];

export const otherCategories = [
  { id: 'kashayam', name: 'Kashayam', icon: 'ri-test-tube-line', description: 'Traditional herbal decoctions.', to: '/products/kashayam' },
  { id: 'churanam', name: 'Churanam', icon: 'ri-flask-line', description: 'Classical herbal powders.', to: '/products/churanam' },
  { id: 'powder', name: 'Powder', icon: 'ri-blaze-line', description: 'Face, oral and wellness powders.', to: '/products/powder' },
  { id: 'selfcare', name: 'Self Care', icon: 'ri-heart-line', description: 'Herbal shampoos, soaps and more.', to: '/products/selfcare' },
];

export const pillars = [
  {
    id: 'mission',
    title: 'Mission',
    icon: 'ri-focus-3-line',
    description:
      'Being a leading manufacturer & supplier in promoting Ayurvedic capsules, syrups and lehyam care medicines across India.',
  },
  {
    id: 'vision',
    title: 'Vision',
    icon: 'ri-eye-line',
    description:
      'To offer people traditional Ayurveda with a touch of technology through never-ending research, developing truly effective herbal products.',
  },
  {
    id: 'values',
    title: 'Values',
    icon: 'ri-heart-3-line',
    description:
      'Quality is the only focus and aim when it comes to our Ayurvedic products, born through constant commitment to Ayurveda and the people we serve.',
  },
];

export const networkPartners = [
  { id: 'retail', label: 'Retail Pharmacy' },
  { id: 'distributor', label: 'Healthcare Distributor' },
  { id: 'medical-store', label: 'Medical Store' },
  { id: 'wellness', label: 'Wellness Center' },
  { id: 'hospital', label: 'Hospital Partner' },
  { id: 'dealer', label: 'Medicine Dealer' },
  { id: 'clinic', label: 'Healthcare Clinic' },
  { id: 'ayurveda', label: 'Ayurveda Distributor' },
  { id: 'supplier', label: 'Medical Supplier' },
  { id: 'retailer', label: 'Wellness Retailer' },
  { id: 'services', label: 'Healthcare Services' },
  { id: 'pharma', label: 'Pharma Distributor' },
];

export const distributorBenefits = [
  {
    id: 'margin',
    icon: 'ri-percent-line',
    title: 'Attractive Margins',
    description: 'Competitive pricing and healthy profit margins on every order.',
  },
  {
    id: 'territory',
    icon: 'ri-map-pin-range-line',
    title: 'Territory Rights',
    description: 'Dedicated area rights so your market stays protected.',
  },
  {
    id: 'marketing',
    icon: 'ri-megaphone-line',
    title: 'Marketing Support',
    description: 'Product literature, branding and promotional material.',
  },
  {
    id: 'supply',
    icon: 'ri-truck-line',
    title: 'Reliable Supply',
    description: 'Consistent stock with fast, on-time pan-India dispatch.',
  },
];

export const partnerReasons = [
  {
    id: 'margins',
    icon: 'ri-percent-line',
    title: 'Higher Margins',
    description: 'Competitive pricing with healthy profit on every order you place.',
  },
  {
    id: 'territory',
    icon: 'ri-map-pin-range-line',
    title: 'Protected Territory',
    description: 'Exclusive area rights so your market stays secured and clash-free.',
  },
  {
    id: 'support',
    icon: 'ri-customer-service-2-line',
    title: 'Full Support',
    description: 'Marketing, branding and on-time supply support, end to end.',
  },
];

export const navLinks = [
  { id: 'home', label: 'Home', to: '/' },
  { id: 'about', label: 'About Us', to: '/about' },
  { id: 'products', label: 'Products', to: '/products' },
  { id: 'certificates', label: 'Certifications', to: '/about#certificates' },
  { id: 'network', label: 'Our Network', to: '/#network' },
  { id: 'distributor', label: 'Distributor', to: '/#distributor-apply' },
  { id: 'contact', label: 'Contact', to: '/contact' },
];

export const productMenu = [
  { id: 'capsules', label: 'Capsules', icon: 'ri-capsule-line', to: '/products/capsules' },
  { id: 'tablet', label: 'Tablets', icon: 'ri-medicine-bottle-line', to: '/products/tablet' },
  { id: 'syrup', label: 'Syrups', icon: 'ri-flask-line', to: '/products/syrup' },
  { id: 'kashayam', label: 'Kashayam', icon: 'ri-test-tube-line', to: '/products/kashayam' },
  { id: 'lehyam', label: 'Lehyam', icon: 'ri-leaf-line', to: '/products/lehyam' },
  { id: 'oil', label: 'Oil', icon: 'ri-drop-line', to: '/products/oil' },
  { id: 'ointments', label: 'Ointments', icon: 'ri-hand-sanitizer-line', to: '/products/ointments' },
  { id: 'churanam', label: 'Churanam', icon: 'ri-flask-line', to: '/products/churanam' },
  { id: 'powder', label: 'Powder', icon: 'ri-blaze-line', to: '/products/powder' },
  { id: 'selfcare', label: 'Self Care', icon: 'ri-heart-line', to: '/products/selfcare' },
];